import lodashSet from 'lodash.set';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';

export type TListOfChildcareProviders = TListOfChildcareProvidersRow[];

export type TListOfChildcareProvidersRow = {
  namesOfChildcareProvider: Nullable<string>;
  address: Nullable<string>;
  socSecOrEmployerIdOfChildcareProvider: Nullable<string>;
  amountPaid: Nullable<string>;
};

export interface DeductionsStateValues {
  evenIfYouHaveExpensesYouMayNotNeedToItemizeThemlinkButton: Nullable<string>;
  doYouWantToListVariousExpensesThatMightImproveYourTaxPosition: Nullable<TYesOrNo>;
  investmentExpenses: Nullable<string>;
  currency: Nullable<string>;
  didYouPayAWealthTaxieTaxOnAssetsAndNotIncome: Nullable<TYesOrNo>;
  detailsAboutTaxPaid: Nullable<string>;
  taxAmount: Nullable<string>;
  didYouPayAnInheritanceTax: Nullable<TYesOrNo>;
  didYouOwnResidentialRealEstateDuringYear: Nullable<TYesOrNo>;
  doYouHaveAMortgagePleaseUploadForm1098: Nullable<string>;
  ifNonUsMortgagePleaseUploadBankStatementShowingTheAmountOfMortgageInterestPaidThroughTheCalendarYear: Nullable<string>;
  didYouPayPropertyTaxesOnTheResidence: Nullable<TYesOrNo>;
  propertyTaxesPaidOnForeignResidence: Nullable<string>;
  propoertyTaxesPaidOnUsResidence: Nullable<string>;
  movingExpensesprovideABreakdownBySpecificExpenseType: Nullable<string>;
  didYouIncurHomePurchaseCosts: Nullable<TYesOrNo>;
  doYouHaveATimeShareThatReportedPropertyTaxesPaid: Nullable<TYesOrNo>;
  doYouHaveAnHsaAccount: Nullable<string>;
  pleaseUploadForms5498SaAnd1099SaIfReceived: Nullable<string>;
  medicalAndDentalExpensesinsurancePremiums: Nullable<string>;
  didYouIncurChildcareOrOtherDependentCareExpenses: Nullable<TYesOrNo>;
  listOfChildcareProviders: TListOfChildcareProviders;
  didYouPayInterestOnStudentLoans: Nullable<string>;
  form1098E: Nullable<string>;
  didYouIncurHigherEducationExpensesForYourselfSpouseOrDependents: Nullable<string>;
  form1098T: Nullable<string>;
  charitableContributionsToUsOrForeignQualifiedOrganizationscandianMexianOrIsraeli: Nullable<string>;
  didYouDonateAVehicleBoatOrAirplaneWithTheClaimedValueOver500: Nullable<TYesOrNo>;
  form1098C: Nullable<string>;
  pleaseListAnyOtherItemsOfIncomeOrExpenseThatYouThinkMayImpactYourUsTaxes: Nullable<string>;
  casualtyAndTheftLossesFromAUsFederallyDeclaredDisaster: Nullable<string>;
  didYouPayAWealthTaxieTaxOnAssetsAndNotIncomedetailsAboutTaxPaid: Nullable<TYesOrNo>;
  didYouPayAWealthTaxieTaxOnAssetsAndNotIncometaxAmount: Nullable<TYesOrNo>;
  didYouPayAnInheritanceTaxdetailsAboutTaxPaid: Nullable<TYesOrNo>;
  didYouPayAnInheritanceTaxtaxAmount: Nullable<TYesOrNo>;
  doesTheJobRelatedExpensesExceedsTheStandardDeduction: Nullable<TYesOrNo>;
  pleaseUploadAllTheRelatedDeductions: Nullable<string>;
  didYouExperienceALossOfMoreThan10OfYourIncomeDueToCasualtyOrTheft: Nullable<TYesOrNo>;
  didYouGiveAnyGiftsWorthMoreThan25ToAnyOnePersonThisYear: Nullable<TYesOrNo>;
  didYouMakeCashDonationsForMoreThan250AtAnyOneTimeThisYear: Nullable<TYesOrNo>;
  didYouDonatePhysicalGoodsThisYear: Nullable<TYesOrNo>;
}

export interface DeductionsState {
  values: DeductionsStateValues;
}

const initialState: DeductionsState = {
  values: {
    evenIfYouHaveExpensesYouMayNotNeedToItemizeThemlinkButton: null,
    doYouWantToListVariousExpensesThatMightImproveYourTaxPosition: null,
    investmentExpenses: null,
    currency: null,
    didYouPayAWealthTaxieTaxOnAssetsAndNotIncome: null,
    detailsAboutTaxPaid: null,
    taxAmount: null,
    didYouPayAnInheritanceTax: null,
    didYouOwnResidentialRealEstateDuringYear: null,
    doYouHaveAMortgagePleaseUploadForm1098: null,
    ifNonUsMortgagePleaseUploadBankStatementShowingTheAmountOfMortgageInterestPaidThroughTheCalendarYear:
      null,
    didYouPayPropertyTaxesOnTheResidence: null,
    propertyTaxesPaidOnForeignResidence: null,
    propoertyTaxesPaidOnUsResidence: null,
    movingExpensesprovideABreakdownBySpecificExpenseType: null,
    didYouIncurHomePurchaseCosts: null,
    doYouHaveAnHsaAccount: null,
    pleaseUploadForms5498SaAnd1099SaIfReceived: null,
    medicalAndDentalExpensesinsurancePremiums: null,
    didYouIncurChildcareOrOtherDependentCareExpenses: null,
    listOfChildcareProviders: [
      {
        namesOfChildcareProvider: null,
        address: null,
        socSecOrEmployerIdOfChildcareProvider: null,
        amountPaid: null,
      },
    ],
    didYouPayInterestOnStudentLoans: null,
    form1098E: null,
    didYouIncurHigherEducationExpensesForYourselfSpouseOrDependents: null,
    form1098T: null,
    charitableContributionsToUsOrForeignQualifiedOrganizationscandianMexianOrIsraeli:
      null,
    didYouDonateAVehicleBoatOrAirplaneWithTheClaimedValueOver500: null,
    form1098C: null,
    pleaseListAnyOtherItemsOfIncomeOrExpenseThatYouThinkMayImpactYourUsTaxes:
      null,
    casualtyAndTheftLossesFromAUsFederallyDeclaredDisaster: null,
    didYouPayAWealthTaxieTaxOnAssetsAndNotIncomedetailsAboutTaxPaid: null,
    didYouPayAWealthTaxieTaxOnAssetsAndNotIncometaxAmount: null,
    didYouPayAnInheritanceTaxdetailsAboutTaxPaid: null,
    didYouPayAnInheritanceTaxtaxAmount: null,
    doesTheJobRelatedExpensesExceedsTheStandardDeduction: null,
    pleaseUploadAllTheRelatedDeductions: null,
    didYouDonatePhysicalGoodsThisYear: null,
    didYouExperienceALossOfMoreThan10OfYourIncomeDueToCasualtyOrTheft: null,
    didYouGiveAnyGiftsWorthMoreThan25ToAnyOnePersonThisYear: null,
    didYouMakeCashDonationsForMoreThan250AtAnyOneTimeThisYear: null,
    doYouHaveATimeShareThatReportedPropertyTaxesPaid: null,
  },
};

const deductionsSlice = createSlice({
  name: 'deductions',
  initialState,
  reducers: {
    update(state, action: PayloadAction<DeductionsStateValues>) {
      state.values = JSON.parse(JSON.stringify(action.payload));
    },
    updateKey(
      state,
      action: PayloadAction<{
        key: keyof DeductionsStateValues | keyof TListOfChildcareProvidersRow;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
    updateFieldArrayKey(
      state,
      action: PayloadAction<{
        key: keyof DeductionsStateValues | keyof TListOfChildcareProvidersRow;
        value: TListOfChildcareProviders;
      }>,
    ) {
      const fieldArray = action.payload.value.map((field) => ({ ...field }));
      if (action.payload.key === 'listOfChildcareProviders') {
        state.values[action.payload.key] = fieldArray;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire.taxesDeductions
              .deductions.values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey, updateFieldArrayKey } =
  deductionsSlice.actions;
export default deductionsSlice.reducer;

export const selectDeductions = (state: RootState) =>
  state.taxQuestionnaire.taxesDeductions.deductions;
